<template>
  <v-dialog v-model="dialog" max-width="520" persistent>
    <v-card>

      <!-- Header -->
      <div style="background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%); padding: 16px 20px; display: flex; align-items: center; gap: 12px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="38">
          <v-icon color="white" size="20">mdi-check-decagram-outline</v-icon>
        </v-avatar>
        <div>
          <div style="font-size: 1rem; font-weight: 700; color: #fff;">Cambiar Estado</div>
          <div style="font-size: 0.75rem; color: rgba(255,255,255,0.65);">Solo la directora académica nacional debe hacer este cambio</div>
        </div>
      </div>

      <v-card-text class="pt-4 pb-2 px-5">

        <v-alert type="warning" dense outlined class="mb-4" style="font-size: 0.82rem;">
          Esta funcionalidad permite cambiar el estado del postgrado de forma consecutiva:
          <strong>0 → 1 → 2 → 3 → 0</strong>
        </v-alert>

        <div class="ap-info-row">
          <span class="ap-label">ID</span>
          <span class="ap-value">{{ prog.id }}</span>
        </div>
        <div class="ap-info-row">
          <span class="ap-label">Postgrado</span>
          <span class="ap-value">{{ prog.nombre }}</span>
        </div>
        <div class="ap-info-row mb-4">
          <span class="ap-label">Fase actual</span>
          <v-chip x-small label :color="faseColor(prog.status)" class="font-weight-medium">
            {{ getFase }}
          </v-chip>
        </div>

        <v-select
          v-model="fase"
          label="Nueva fase"
          :items="fases"
          item-value="v" item-text="t"
          outlined dense
          prepend-inner-icon="mdi-swap-horizontal"
        />

      </v-card-text>

      <v-card-actions class="px-5 pb-4">
        <v-spacer />
        <v-btn text @click="cerrar">Cancelar</v-btn>
        <v-btn color="indigo darken-1" dark depressed :loading="loading" @click="enviar">
          <v-icon left small>mdi-check</v-icon> Cambiar estado
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import gql from 'graphql-tag';

export default {
  data() {
    return {
      loading: false,
      dialog: false,
      fase: -1,
      prog: {},
      fases: [
        { v: 0, t: '0. Por aprobar' },
        { v: 1, t: '1. Aprobado' },
        { v: 2, t: '2. Permitir crear programa' },
        { v: 3, t: '3. No permitir crear programa' },
      ],
    };
  },
  computed: {
    getFase() {
      const fase = this.prog.status;
      if (fase == 0) return '0 Por aprobar';
      if (fase == 1) return '1 Aprobado';
      if (fase == 2) return '2 Permitir crear programa';
      if (fase == 3) return '3 No permitir crear programa';
      return 'Desconocido: ' + fase;
    },
  },
  methods: {
    faseColor(status) {
      if (status == 0) return 'red lighten-5 red--text text--darken-3';
      if (status == 1) return 'orange lighten-5 orange--text text--darken-3';
      if (status == 2) return 'green lighten-5 green--text text--darken-3';
      if (status == 3) return 'grey lighten-3 grey--text text--darken-2';
      return 'grey lighten-3';
    },
    async openmodal(xitem) {
      this.prog = xitem;
      this.fase = this.prog.status;
      this.loading = false;
      const perm = this.permiso();
      if (!perm) {
        this.$root.$notify.show('No dispone de los privilegios necesarios para realizar esta modificación.', { color: 'red', x: 'right' });
        this.dialog = false;
      } else {
        this.dialog = true;
      }
    },
    cerrar() {
      this.dialog = false;
    },
    permiso() {
      // nuevos permisos 
      const apidev = process.env.VUE_APP_GRAPHQL;
      if (apidev.includes('apidev')) {
        this.$root.$notify.show('Autorizado en modo pruebas', { color: 'purple', x: 'right' });
        return true;
      }
      const negocioid = this.$store.state.CARGO.sede.unidad_negocio;
      const sedeid    = this.$store.state.CARGO.sede.id;
      const userid    = this.$store.state.DATA_USER.id;
      const carg      = this.$store.state.CARGO.id;
      const claudia_upi = 65958;
      if (negocioid == 1) {
        return userid == 95 || userid == 35886 || userid == 59716 || userid == 73 || userid == claudia_upi;
      
      } else if (negocioid == 10) {
        // en teoria aqui no deberia aprobarse porque se usa proyectos pero para upi nose :)
        return userid == -43 || userid == 8017 || userid == 73 || userid == 864 || userid == 35886 || userid == 59716 || userid == claudia_upi;
      
      } else if (negocioid == 12) {
        return userid == 46812 || userid == 25174 || carg == 6;
      
      } else if (negocioid == 14) {
        const ispaula_upi = sedeid == 121 && userid == 12988;
        return userid == 12988 || userid == 104802 || carg == -6 || ispaula_upi;
      
      } else if (negocioid == 15) {
        const ispaula_upi = sedeid == 121 && userid == 12988;
        return userid == claudia_upi || userid == 76447 || userid == -43 || ispaula_upi;
      
      } else if (negocioid == 2) {
        return userid == 95 || userid == 35886 || userid == 113600 || userid == 59716;
      }
      return true;
    },
    async enviar() {
      this.loading = true;
      const sql = gql`mutation{ cambiarPostgradoStatus(input:{id:${this.prog.id},status:${this.fase}}){ok,errors{message}} }`;
      const res = await this.$apollo.mutate({ mutation: sql }).then(({ data }) => data).catch((e) => e);
      this.loading = false;
      if (res && res.cambiarPostgradoStatus) {
        if (res.cambiarPostgradoStatus.ok) {
          this.prog.status = this.fase;
          this.$root.$notify.show('Fase cambiada', { color: 'green', x: 'right' });
          this.dialog = false;
        } else {
          let vals = '';
          res.cambiarPostgradoStatus.errors.forEach((e) => { vals += e.message + '. \n\t'; });
          this.$root.$notify.show(vals, { color: 'red', x: 'right' });
        }
      }
    },
  },
};
</script>

<style scoped>
.ap-info-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  font-size: 0.85rem;
}
.ap-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #7986cb;
  min-width: 90px;
}
.ap-value {
  color: #283593;
  font-weight: 500;
}
</style>
